<script>
    export let event;
</script>

{#if event.carousel && event.carousel.items}
    <div class="row">
        {#each event.carousel.items as {thumbnail_url} }
            {#if thumbnail_url}
                <div class="col-6">
                    <img src="{thumbnail_url}" alt="..." class="img-thumbnail">
                </div>
            {/if}
        {/each}
    </div>
{/if}